import { Injectable } from '@angular/core';
import {environment} from '../../../environments/environment';
import {Project, Service, ServiceOrder} from '@app/shared';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BehaviorSubject, Observable} from 'rxjs';

interface GlobalSearchRsp {
  data: {
    projects: {
      lastRow: number,
      rows?: Project[],
    },
    services: {
      lastRow: number,
      rows?: Service[],
    },
    "serviceOrders": {
      lastRow: number,
      rows?: ServiceOrder[],
    }
  },
  success: boolean,
  message: string,
  messageType: string,
  statusCode: number
}

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {

  globalSearvchUrl: string = environment.coreApiBaseUrl + '/api/global/search';

  _globalSearchResult$ = new BehaviorSubject<GlobalSearchRsp | null>(null);

  set globalSearchResult(value: GlobalSearchRsp) {
    this._globalSearchResult$.next(value);
  }

  get globalSearchResult(): Observable<GlobalSearchRsp | null> {
    return this._globalSearchResult$ as Observable<GlobalSearchRsp | null>;
  }

  _globalSearchValue$ = new BehaviorSubject<string>('');

  set globalSearchValue(value: string) {
    this._globalSearchValue$.next(value);
  }

  get globalSearchValue(): Observable<string> {
    return this._globalSearchValue$ as Observable<string>;
  }

  loading$ = new BehaviorSubject<boolean>(false);

  constructor(private http: HttpClient) { }

  search(searchTerm: string, companyId: number): Observable<GlobalSearchRsp> {
    const headers = new HttpHeaders({
      'companyId': companyId.toString()
    });

    return this.http.get<GlobalSearchRsp>(
      `${this.globalSearvchUrl}?searchTerm=${encodeURIComponent(searchTerm)}`,
      { headers }
    );
  }

}
